import { Component, OnInit, Input, Inject, SimpleChanges, EventEmitter, Output } from '@angular/core';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from '../status/status-constant';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { CoreService } from 'src/app/applicationModules/core/services/coreService/core.service';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { ToastrService } from 'ngx-toastr';
import { MatRadioChange } from '@angular/material/radio';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
export interface State {
  name: string;
  email: string;
  role: string;
  pic: string;
}

@Component({
  selector: 'app-addtask',
  templateUrl: './addtask.component.html',
  styleUrls: ['./addtask.component.scss'] 
})

export class AddTaskComponent implements OnInit {

  colors = [
    {
     colname:'#F5D428'     
   },
   {
     colname:'#6FC040'
   },
   {
     colname:'#52A7F9'
    },
    {
      colname:'#EF8F1E'
    },
    {
     colname:'#EC5C58'
    },
    {
      colname:'#B36AE2'
    },
 ]
  @Input() typeIdDrp : number=0;
  @Output() getCloseCreateTask = new EventEmitter<boolean>();
  @Output() getSaveTask = new EventEmitter<boolean>(); 
  @Output() taskListTaskSaved = new EventEmitter<boolean>();
  @Input() taskId : number=0;
  @Input() taskListID : number=0;
  @Input() moduleName : string='';
  @Input() name : string='';
  @Input() email : string='';
  @Input() imageUrl : string='';
  @Input() typeId : number=0;
  @Input() transactionID : number=0;
  @Input() openFroms : string='';

  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;
  myTaskForm: FormGroup; 
  folderList: any[] = []; 
  folderId:number=0; 
  OfficeIDList: any=[];
  myOfficeID: number=0;
  showColorPannel = false;
  selectedColor:string = '#a59f9f';
  spinner:boolean=false;
  stateCtrl = new FormControl();
  stateCtrlValue: string='';
  filteredStates: Observable<State[]>;
  objectList: any = [];
  CoreShowName: string = "";
  ContactShowName: string = "";
  CompanyShowName: string = "";
  LoggedInEmailId: string = "";

  constructor(private formBuilder: FormBuilder, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private settingsService: SettingService,
    private statusConst: StatusConstant, private coreService: CoreService, 
    private toastr: ToastrService) {   
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId')?? '';
     this.organizationId = sessionStorage.getItem('organizationID')?? '';
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey,encryptedtoken);   
    this.currentUser = jwt_decode(token); 
    var offices = JSON.parse(sessionStorage.getItem('officeList') ?? '[]');
    offices.forEach((oe:any) => {
    this.OfficeIDList.push(oe.officeID);
    if(oe.isMyoffice==true)
      this.myOfficeID=oe.officeID;
    });
     this.stateCtrl.setValue(this.stateCtrlValue);
        this.filteredStates = this.stateCtrl.valueChanges.pipe(
          startWith(''), map((state) => (state ? this._filterStates(state) : this.states.slice()))
      ); 
  }

   states = this.objectList;
  
    private _filterStates(value: string): State[] {
      const filterValue = value.toLowerCase();
      return this.states.filter((state:any) => state.name.toLowerCase().indexOf(filterValue) === 0);
    }

  ngOnChanges(changes: SimpleChanges) {
    let group = {};
    this.myTaskForm = new FormGroup(group);
    this.createFormTask();
    this.menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var SelectedCore = [];
    var SelectedContact = [];
    var SelectedCompany = [];

    SelectedCore = this.menuModulesList.filter((x:any) => x.mainModuleName == 'Core');
    if (SelectedCore.length > 0) {
      this.CoreShowName = SelectedCore[0].orgModuleName;
    }

    SelectedContact = this.menuModulesList.filter((x:any) => x.mainModuleName == 'Contact');
    if (SelectedContact.length > 0) {
      this.ContactShowName = SelectedContact[0].orgModuleName;
    }

    SelectedCompany = this.menuModulesList.filter((x:any) => x.mainModuleName == 'Company');
    if (SelectedCompany.length > 0) {
      this.CompanyShowName = SelectedCompany[0].orgModuleName;
    }   
  }

  ngOnInit(): void {
    let group = {};
    this.myTaskForm = new FormGroup(group);
    this.createFormTask();  
    this.menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var SelectedCore = [];
    var SelectedContact = [];
    var SelectedCompany = [];

    SelectedCore = this.menuModulesList.filter((x:any) => x.mainModuleName == 'Core');
    if (SelectedCore.length > 0) {
      this.CoreShowName = SelectedCore[0].orgModuleName;
    }

    SelectedContact = this.menuModulesList.filter((x:any) => x.mainModuleName == 'Contact');
    if (SelectedContact.length > 0) {
      this.ContactShowName = SelectedContact[0].orgModuleName;
    }

    SelectedCompany = this.menuModulesList.filter((x:any) => x.mainModuleName == 'Company');
    if (SelectedCompany.length > 0) {
      this.CompanyShowName = SelectedCompany[0].orgModuleName;
    }   

    if(this.openFroms=="Dashboard"){
       this.ShowContactBox = false;
       this.ShowRoleBox = false;
       this.ShowEmailBox = false;
       this.ShowUserBox = true;
       this.ShowRelationshipBox = false;
       this.entityTypeAssignee = 4;
       this.selectedAssignedTo=[];
       this.isAssignedEntity = true;
       this.LoggedInEmailId = sessionStorage.getItem('email');
       this.getUserListCoreImplementationDashboard(this.LoggedInEmailId);
    }
  }     

  createFormTask(): void {
   this.myTaskForm = this.formBuilder.group({
    title: ['', [Validators.required]],
    description: [''],
    dueDate: [''],
    startDate: [''],
    isInternal:false,
    isDueDateTrigger:false,
   },);
  } 
  
  async SaveTaskDetails(data:any){
    if(data.dueDate!=''){
      data.dueDate= new Date(data.dueDate.getFullYear(), data.dueDate.getMonth(), data.dueDate.getDate(), data.dueDate.getHours(), data.dueDate.getMinutes() - data.dueDate.getTimezoneOffset()).toISOString();
      //data.dueDate.setDate(data.dueDate.getDate() +1); 
    }
    if(data.startDate!=''){
      data.startDate= new Date(data.startDate.getFullYear(), data.startDate.getMonth(), data.startDate.getDate(), data.startDate.getHours(), data.startDate.getMinutes() - data.startDate.getTimezoneOffset()).toISOString();
      //data.dueDate.setDate(data.dueDate.getDate() +1); 
    }
    if(this.moduleName == "Task"){
        //For Save Task
      if(this.taskId==0 && this.taskListID==0){
       this.SaveTask(data);
        return;
       }
      if(this.taskId==0 && this.taskListID>0){
       this.SaveTaskList(data);
      }
    }else{
      if(this.taskId==0 && this.taskListID==0){
        this.SaveTask3C(data);
         return;
        }
       if(this.taskId==0 && this.taskListID>0){
        this.SaveTaskList3C(data);
       }
    }
   

    // //For Save SubTask
    // if(this.taskId>0 && this.taskListID==0){
    //   this.SaveSubTask(data);
    //   return;
    // }   
  }


  async SaveTask(data:any){
    if(data.isInternal==false){
      data.isInternal=true;
    }else{
      data.isInternal=false;
    }
    if(data.isDueDateTrigger==true){
      data.isDueDateTrigger=true;
    }else{
      data.isDueDateTrigger=false;
    }

     //=====Check select Assigned To ===//
    // Contact-1,Role-2,Email-3,User-4
    this.taskAssignedEntity = [];
    this.taskAttachedEntity = [];

    if(this.selectedAssignedTo==0){
      this.entityTypeAssignee=0;
    }

     if (this.selectedAssignedTo.length > 0) {
        for (var i = 0, len = this.selectedAssignedTo.length; i < len; ++i) {
          var objj = {
            email: this.selectedAssignedTo[i].email,
            taskAssignedEntityID: this.selectedAssignedTo[i].taskAssignedEntityID,
            taskID: this.taskId,           
            contactID: this.selectedAssignedTo[i].contactID,
            roleID: this.selectedAssignedTo[i].roleID,
            userID: this.selectedAssignedTo[i].userID,
            entityTypeAssignee:this.selectedAssignedTo[i].entityTypeAssignee,          
            assigneeName:this.selectedAssignedTo[i].name,
          }
          this.taskAssignedEntity.push(objj);
        }
     }   
   
    // For Core 
    if (this.entityTypeAttached == 1) {
      if (this.attachedToSelectedCore.length > 0) {
        for (var i = 0, len = this.attachedToSelectedCore.length; i < len; ++i) {
          var taskAttachedEntityID = this.attachedToSelectedCore[i].taskAttachedEntityID;
          var isDeleted = this.attachedToSelectedCore[i].isDeleted;
          if (taskAttachedEntityID == 0 && isDeleted == true) {

          } else {
            var coreAttached = {
              taskAttachedEntityID: this.attachedToSelectedCore[i].taskAttachedEntityID,
              taskID: this.taskId,
              attachedEntityID: this.attachedToSelectedCore[i].coreID,
              attachedEntityRelation: "",
              attachedEntityTitle: this.attachedToSelectedCore[i].title,
              attachedEntityName: this.attachedToSelectedCore[i].name,
              attachedEntityEmail: this.attachedToSelectedCore[i].email,
              attachedEntityTypeID: this.attachedToSelectedCore[i].typeID,
              isDeleted: this.attachedToSelectedCore[i].isDeleted,
            }
            this.taskAttachedEntity.push(coreAttached);
          }
        }
      }
    }

    // For Contact 
    if (this.entityTypeAttached == 2) {
      if (this.attachedToSelectedContact.length > 0) {
        for (var i = 0, len = this.attachedToSelectedContact.length; i < len; ++i) {
          var taskAttachedEntityID = this.attachedToSelectedContact[i].taskAttachedEntityID;
          var isDeleted = this.attachedToSelectedContact[i].isDeleted;
          if (taskAttachedEntityID == 0 && isDeleted == true) {

          } else {
            var contactAttached = {
              taskAttachedEntityID: this.attachedToSelectedContact[i].taskAttachedEntityID,
              taskID: this.taskId,
              attachedEntityID: this.attachedToSelectedContact[i].contactID,
              attachedEntityRelation: "",
              attachedEntityTitle: this.attachedToSelectedContact[i].title,
              attachedEntityName: this.attachedToSelectedContact[i].name,
              attachedEntityEmail: this.attachedToSelectedContact[i].email,
              attachedEntityTypeID: this.attachedToSelectedContact[i].typeID,
              isDeleted: this.attachedToSelectedContact[i].isDeleted,
            }
            this.taskAttachedEntity.push(contactAttached);
          }
        }
      }
    }

    // For Company 
    if (this.entityTypeAttached == 3) {
      if (this.attachedToSelectedCompany.length > 0) {
        for (var i = 0, len = this.attachedToSelectedCompany.length; i < len; ++i) {
          var taskAttachedEntityID = this.attachedToSelectedCompany[i].taskAttachedEntityID;
          var isDeleted = this.attachedToSelectedCompany[i].isDeleted;
          if (taskAttachedEntityID == 0 && isDeleted == true) {

          } else {
            var companyAttached = {
              taskAttachedEntityID: this.attachedToSelectedCompany[i].taskAttachedEntityID,
              taskID: this.taskId,
              attachedEntityID: this.attachedToSelectedCompany[i].companyID,
              attachedEntityRelation: "",
              attachedEntityTitle: this.attachedToSelectedCompany[i].title,
              attachedEntityName: this.attachedToSelectedCompany[i].name,
              attachedEntityEmail: this.attachedToSelectedCompany[i].email,
              attachedEntityTypeID: this.attachedToSelectedCompany[i].typeID,
              isDeleted: this.attachedToSelectedCompany[i].isDeleted,
            }
            this.taskAttachedEntity.push(companyAttached);
          }
        }
      }
    }

    var ReqModel={
      parentTaskID: 0,
      tasklistID:0,
      title: data.title,
      description: data.description,
      colourCode: this.selectedColor,
      isInternal: data.isInternal,
      isDueDateTrigger:data.isDueDateTrigger,
      dueDate: data.dueDate,
      startDate: data.startDate,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,

      entityTypeAttached: this.entityTypeAttached,
      entityTypeAssignee: this.entityTypeAssignee,

      taskAssignedEntity: this.taskAssignedEntity,
      taskAttachedEntity: this.taskAttachedEntity,
    }
   // return;
    this.spinner=true;
    this.myTaskForm.markAsPristine();
    const result = await this.coreService.addTask(ReqModel).toPromise();
    if (result.status === this.statusConst.statusSuccess) {
      this.spinner=false;
      this.close();
      this.myTaskForm.reset();
      this.getSaveTask.emit(false);
      this.toastr.success("Task created successfully.", '', {
        timeOut: 3000,
      });
    }
    else {
      this.spinner=false;
      this.close();
    } 
  }
  

  async SaveTaskList(data:any){
    if(data.isInternal==false){
      data.isInternal=true;
    }else{
      data.isInternal=false;
    }
    if(data.isDueDateTrigger==true){
      data.isDueDateTrigger=true;
    }else{
      data.isDueDateTrigger=false;
    }

     //=====Check select Assigned To ===//
    // Contact-1,Role-2,Email-3,User-4
    this.taskAssignedEntity = [];
    this.taskAttachedEntity = [];

    if(this.selectedAssignedTo==0){
      this.entityTypeAssignee=0;
    }

     if (this.selectedAssignedTo.length > 0) {
        for (var i = 0, len = this.selectedAssignedTo.length; i < len; ++i) {
          var objj = {
            email: this.selectedAssignedTo[i].email,
            taskAssignedEntityID: this.selectedAssignedTo[i].taskAssignedEntityID,
            taskID: this.taskId,           
            contactID: this.selectedAssignedTo[i].contactID,
            roleID: this.selectedAssignedTo[i].roleID,
            userID: this.selectedAssignedTo[i].userID,
            entityTypeAssignee:this.selectedAssignedTo[i].entityTypeAssignee,          
            assigneeName:this.selectedAssignedTo[i].name,
          }
          this.taskAssignedEntity.push(objj);
        }
     }   
   
    // For Core 
    if (this.entityTypeAttached == 1) {
      if (this.attachedToSelectedCore.length > 0) {
        for (var i = 0, len = this.attachedToSelectedCore.length; i < len; ++i) {
          var taskAttachedEntityID = this.attachedToSelectedCore[i].taskAttachedEntityID;
          var isDeleted = this.attachedToSelectedCore[i].isDeleted;
          if (taskAttachedEntityID == 0 && isDeleted == true) {

          } else {
            var coreAttached = {
              taskAttachedEntityID: this.attachedToSelectedCore[i].taskAttachedEntityID,
              taskID: this.taskId,
              attachedEntityID: this.attachedToSelectedCore[i].coreID,
              attachedEntityRelation: "",
              attachedEntityTitle: this.attachedToSelectedCore[i].title,
              attachedEntityName: this.attachedToSelectedCore[i].name,
              attachedEntityEmail: this.attachedToSelectedCore[i].email,
              attachedEntityTypeID: this.attachedToSelectedCore[i].typeID,
              isDeleted: this.attachedToSelectedCore[i].isDeleted,
            }
            this.taskAttachedEntity.push(coreAttached);
          }
        }
      }
    }

    // For Contact 
    if (this.entityTypeAttached == 2) {
      if (this.attachedToSelectedContact.length > 0) {
        for (var i = 0, len = this.attachedToSelectedContact.length; i < len; ++i) {
          var taskAttachedEntityID = this.attachedToSelectedContact[i].taskAttachedEntityID;
          var isDeleted = this.attachedToSelectedContact[i].isDeleted;
          if (taskAttachedEntityID == 0 && isDeleted == true) {

          } else {
            var contactAttached = {
              taskAttachedEntityID: this.attachedToSelectedContact[i].taskAttachedEntityID,
              taskID: this.taskId,
              attachedEntityID: this.attachedToSelectedContact[i].contactID,
              attachedEntityRelation: "",
              attachedEntityTitle: this.attachedToSelectedContact[i].title,
              attachedEntityName: this.attachedToSelectedContact[i].name,
              attachedEntityEmail: this.attachedToSelectedContact[i].email,
              attachedEntityTypeID: this.attachedToSelectedContact[i].typeID,
              isDeleted: this.attachedToSelectedContact[i].isDeleted,
            }
            this.taskAttachedEntity.push(contactAttached);
          }
        }
      }
    }

    // For Company 
    if (this.entityTypeAttached == 3) {
      if (this.attachedToSelectedCompany.length > 0) {
        for (var i = 0, len = this.attachedToSelectedCompany.length; i < len; ++i) {
          var taskAttachedEntityID = this.attachedToSelectedCompany[i].taskAttachedEntityID;
          var isDeleted = this.attachedToSelectedCompany[i].isDeleted;
          if (taskAttachedEntityID == 0 && isDeleted == true) {

          } else {
            var companyAttached = {
              taskAttachedEntityID: this.attachedToSelectedCompany[i].taskAttachedEntityID,
              taskID: this.taskId,
              attachedEntityID: this.attachedToSelectedCompany[i].companyID,
              attachedEntityRelation: "",
              attachedEntityTitle: this.attachedToSelectedCompany[i].title,
              attachedEntityName: this.attachedToSelectedCompany[i].name,
              attachedEntityEmail: this.attachedToSelectedCompany[i].email,
              attachedEntityTypeID: this.attachedToSelectedCompany[i].typeID,
              isDeleted: this.attachedToSelectedCompany[i].isDeleted,
            }
            this.taskAttachedEntity.push(companyAttached);
          }
        }
      }
    }


    var ReqModel={
      parentTaskID: 0,
      tasklistID:this.taskListID,
      title: data.title,
      description: data.description,
      colourCode: this.selectedColor,
      isInternal: data.isInternal,
      isDueDateTrigger:data.isDueDateTrigger,
      dueDate: data.dueDate,
      startDate: data.startDate,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,

      entityTypeAttached: this.entityTypeAttached,
      entityTypeAssignee: this.entityTypeAssignee,

      taskAssignedEntity: this.taskAssignedEntity,
      taskAttachedEntity: this.taskAttachedEntity,
    }
   // return;
    this.spinner=true;
    this.myTaskForm.markAsPristine();
    const result = await this.coreService.addTask(ReqModel).toPromise();
    if (result.status === this.statusConst.statusSuccess) {
      this.spinner=false;
      this.close();
      this.myTaskForm.reset();
      this.getSaveTask.emit(false);
      this.taskListTaskSaved.emit(true);
      this.toastr.success("Created successfully.", '', {
        timeOut: 3000,
      });
    }
    else {
      this.spinner=false;
      this.close();
    } 
  }


  async SaveTask3C(data:any){
    if(data.isInternal==false){
      data.isInternal=true;
    }else{
      data.isInternal=false;
    }
    if(data.isDueDateTrigger==true){
      data.isDueDateTrigger=true;
    }else{
      data.isDueDateTrigger=false;
    }

     //=====Check select Assigned To ===//
    // Contact-1,Role-2,Email-3,User-4
    this.taskAssignedEntity = [];
    this.taskAttachedEntity = [];

    if(this.selectedAssignedTo==0){
      this.entityTypeAssignee=0;
    }

     if (this.selectedAssignedTo.length > 0) {
        for (var i = 0, len = this.selectedAssignedTo.length; i < len; ++i) {
          var objj = {
            email: this.selectedAssignedTo[i].email,
            taskAssignedEntityID: this.selectedAssignedTo[i].taskAssignedEntityID,
            taskID: this.taskId,           
            contactID: this.selectedAssignedTo[i].contactID,
            roleID: this.selectedAssignedTo[i].roleID,
            userID: this.selectedAssignedTo[i].userID,
            entityTypeAssignee:this.selectedAssignedTo[i].entityTypeAssignee,          
            assigneeName:this.selectedAssignedTo[i].name,
          }
          this.taskAssignedEntity.push(objj);
        }
     }   
   
    // For Core 
    if (this.entityTypeAttached == 1) {
      if (this.attachedToSelectedCore.length > 0) {
        for (var i = 0, len = this.attachedToSelectedCore.length; i < len; ++i) {
          var taskAttachedEntityID = this.attachedToSelectedCore[i].taskAttachedEntityID;
          var isDeleted = this.attachedToSelectedCore[i].isDeleted;
          if (taskAttachedEntityID == 0 && isDeleted == true) {

          } else {
            var coreAttached = {
              taskAttachedEntityID: this.attachedToSelectedCore[i].taskAttachedEntityID,
              taskID: this.taskId,
              attachedEntityID: this.attachedToSelectedCore[i].coreID,
              attachedEntityRelation: "",
              attachedEntityTitle: this.attachedToSelectedCore[i].title,
              attachedEntityName: this.attachedToSelectedCore[i].name,
              attachedEntityEmail: this.attachedToSelectedCore[i].email,
              attachedEntityTypeID: this.attachedToSelectedCore[i].typeID,
              isDeleted: this.attachedToSelectedCore[i].isDeleted,
            }
            this.taskAttachedEntity.push(coreAttached);
          }
        }
      }
    }

    // For Contact 
    if (this.entityTypeAttached == 2) {
      if (this.attachedToSelectedContact.length > 0) {
        for (var i = 0, len = this.attachedToSelectedContact.length; i < len; ++i) {
          var taskAttachedEntityID = this.attachedToSelectedContact[i].taskAttachedEntityID;
          var isDeleted = this.attachedToSelectedContact[i].isDeleted;
          if (taskAttachedEntityID == 0 && isDeleted == true) {

          } else {
            var contactAttached = {
              taskAttachedEntityID: this.attachedToSelectedContact[i].taskAttachedEntityID,
              taskID: this.taskId,
              attachedEntityID: this.attachedToSelectedContact[i].contactID,
              attachedEntityRelation: "",
              attachedEntityTitle: this.attachedToSelectedContact[i].title,
              attachedEntityName: this.attachedToSelectedContact[i].name,
              attachedEntityEmail: this.attachedToSelectedContact[i].email,
              attachedEntityTypeID: this.attachedToSelectedContact[i].typeID,
              isDeleted: this.attachedToSelectedContact[i].isDeleted,
            }
            this.taskAttachedEntity.push(contactAttached);
          }
        }
      }
    }

    // For Company 
    if (this.entityTypeAttached == 3) {
      if (this.attachedToSelectedCompany.length > 0) {
        for (var i = 0, len = this.attachedToSelectedCompany.length; i < len; ++i) {
          var taskAttachedEntityID = this.attachedToSelectedCompany[i].taskAttachedEntityID;
          var isDeleted = this.attachedToSelectedCompany[i].isDeleted;
          if (taskAttachedEntityID == 0 && isDeleted == true) {

          } else {
            var companyAttached = {
              taskAttachedEntityID: this.attachedToSelectedCompany[i].taskAttachedEntityID,
              taskID: this.taskId,
              attachedEntityID: this.attachedToSelectedCompany[i].companyID,
              attachedEntityRelation: "",
              attachedEntityTitle: this.attachedToSelectedCompany[i].title,
              attachedEntityName: this.attachedToSelectedCompany[i].name,
              attachedEntityEmail: this.attachedToSelectedCompany[i].email,
              attachedEntityTypeID: this.attachedToSelectedCompany[i].typeID,
              isDeleted: this.attachedToSelectedCompany[i].isDeleted,
            }
            this.taskAttachedEntity.push(companyAttached);
          }
        }
      }
    }

    var ReqModel={
      parentTaskID: 0,
      tasklistID:0,
      title: data.title,
      description: data.description,
      colourCode: this.selectedColor,
      isInternal: data.isInternal,
      isDueDateTrigger:data.isDueDateTrigger,
      dueDate: data.dueDate,
      startDate: data.startDate,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      entityTypeAttached: this.typeId,
      attached3C:{
        taskAttachedEntityID: 0,
        taskID: 0,
        attachedEntityID: this.transactionID,
        attachedEntityRelation: "",
        attachedEntityTitle: "",
        attachedEntityName: this.name,
        attachedEntityEmail: this.email,
        attachedEntityTypeID: this.typeIdDrp,
        imageUrl: this.imageUrl,
        organizationID: Number(this.organizationId),
        officeID: this.myOfficeID,
        //createdBy: this.currentUser.UID,
      },
     
      entityTypeAssignee: this.entityTypeAssignee,

      taskAssignedEntity: this.taskAssignedEntity,
      taskAttachedEntity: this.taskAttachedEntity,
    }
   // return;
    this.spinner=true;
    this.myTaskForm.markAsPristine();
    const result = await this.coreService.addTask(ReqModel).toPromise();
    if (result.status === this.statusConst.statusSuccess) {
      this.spinner=false;
      this.close();
      this.myTaskForm.reset();
      this.getSaveTask.emit(false);
      this.toastr.success("Task created successfully.", '', {
        timeOut: 3000,
      });
    }
    else {
      this.spinner=false;
      this.close();
    } 
  }
  

  async SaveTaskList3C(data){
    if(data.isInternal==false){
      data.isInternal=true;
    }else{
      data.isInternal=false;
    }
    if(data.isDueDateTrigger==true){
      data.isDueDateTrigger=true;
    }else{
      data.isDueDateTrigger=false;
    }

     //=====Check select Assigned To ===//
    // Contact-1,Role-2,Email-3,User-4
    this.taskAssignedEntity = [];
    this.taskAttachedEntity = [];

    if(this.selectedAssignedTo==0){
      this.entityTypeAssignee=0;
    }

     if (this.selectedAssignedTo.length > 0) {
        for (var i = 0, len = this.selectedAssignedTo.length; i < len; ++i) {
          var objj = {
            email: this.selectedAssignedTo[i].email,
            taskAssignedEntityID: this.selectedAssignedTo[i].taskAssignedEntityID,
            taskID: this.taskId,           
            contactID: this.selectedAssignedTo[i].contactID,
            roleID: this.selectedAssignedTo[i].roleID,
            userID: this.selectedAssignedTo[i].userID,
            entityTypeAssignee:this.selectedAssignedTo[i].entityTypeAssignee,          
            assigneeName:this.selectedAssignedTo[i].name,
          }
          this.taskAssignedEntity.push(objj);
        }
     }   
   
    // For Core 
    if (this.entityTypeAttached == 1) {
      if (this.attachedToSelectedCore.length > 0) {
        for (var i = 0, len = this.attachedToSelectedCore.length; i < len; ++i) {
          var taskAttachedEntityID = this.attachedToSelectedCore[i].taskAttachedEntityID;
          var isDeleted = this.attachedToSelectedCore[i].isDeleted;
          if (taskAttachedEntityID == 0 && isDeleted == true) {

          } else {
            var coreAttached = {
              taskAttachedEntityID: this.attachedToSelectedCore[i].taskAttachedEntityID,
              taskID: this.taskId,
              attachedEntityID: this.attachedToSelectedCore[i].coreID,
              attachedEntityRelation: "",
              attachedEntityTitle: this.attachedToSelectedCore[i].title,
              attachedEntityName: this.attachedToSelectedCore[i].name,
              attachedEntityEmail: this.attachedToSelectedCore[i].email,
              attachedEntityTypeID: this.attachedToSelectedCore[i].typeID,
              isDeleted: this.attachedToSelectedCore[i].isDeleted,
            }
            this.taskAttachedEntity.push(coreAttached);
          }
        }
      }
    }

    // For Contact 
    if (this.entityTypeAttached == 2) {
      if (this.attachedToSelectedContact.length > 0) {
        for (var i = 0, len = this.attachedToSelectedContact.length; i < len; ++i) {
          var taskAttachedEntityID = this.attachedToSelectedContact[i].taskAttachedEntityID;
          var isDeleted = this.attachedToSelectedContact[i].isDeleted;
          if (taskAttachedEntityID == 0 && isDeleted == true) {

          } else {
            var contactAttached = {
              taskAttachedEntityID: this.attachedToSelectedContact[i].taskAttachedEntityID,
              taskID: this.taskId,
              attachedEntityID: this.attachedToSelectedContact[i].contactID,
              attachedEntityRelation: "",
              attachedEntityTitle: this.attachedToSelectedContact[i].title,
              attachedEntityName: this.attachedToSelectedContact[i].name,
              attachedEntityEmail: this.attachedToSelectedContact[i].email,
              attachedEntityTypeID: this.attachedToSelectedContact[i].typeID,
              isDeleted: this.attachedToSelectedContact[i].isDeleted,
            }
            this.taskAttachedEntity.push(contactAttached);
          }
        }
      }
    }

    // For Company 
    if (this.entityTypeAttached == 3) {
      if (this.attachedToSelectedCompany.length > 0) {
        for (var i = 0, len = this.attachedToSelectedCompany.length; i < len; ++i) {
          var taskAttachedEntityID = this.attachedToSelectedCompany[i].taskAttachedEntityID;
          var isDeleted = this.attachedToSelectedCompany[i].isDeleted;
          if (taskAttachedEntityID == 0 && isDeleted == true) {

          } else {
            var companyAttached = {
              taskAttachedEntityID: this.attachedToSelectedCompany[i].taskAttachedEntityID,
              taskID: this.taskId,
              attachedEntityID: this.attachedToSelectedCompany[i].companyID,
              attachedEntityRelation: "",
              attachedEntityTitle: this.attachedToSelectedCompany[i].title,
              attachedEntityName: this.attachedToSelectedCompany[i].name,
              attachedEntityEmail: this.attachedToSelectedCompany[i].email,
              attachedEntityTypeID: this.attachedToSelectedCompany[i].typeID,
              isDeleted: this.attachedToSelectedCompany[i].isDeleted,
            }
            this.taskAttachedEntity.push(companyAttached);
          }
        }
      }
    }
    
    var ReqModel={
      parentTaskID: 0,
      tasklistID:this.taskListID,
      title: data.title,
      description: data.description,
      colourCode: this.selectedColor,
      isInternal: data.isInternal,
      isDueDateTrigger: data.isDueDateTrigger,
      dueDate: data.dueDate,
      startDate: data.startDate,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      entityTypeAttached: this.typeId,
      attached3C:{
        taskAttachedEntityID: 0,
        taskID: 0,
        attachedEntityID: this.transactionID,         
        attachedEntityName: this.name,
        attachedEntityEmail: this.email,
        attachedEntityTypeID: this.typeIdDrp,
        imageUrl: this.imageUrl,
        organizationID: Number(this.organizationId),
        officeID: this.myOfficeID,
      },
      entityTypeAssignee: this.entityTypeAssignee,

      taskAssignedEntity: this.taskAssignedEntity,
      taskAttachedEntity: this.taskAttachedEntity,
    }
   // return;
    this.spinner=true;
    this.myTaskForm.markAsPristine();
    const result = await this.coreService.addTask(ReqModel).toPromise();
    if (result.status === this.statusConst.statusSuccess) {
      this.spinner=false;
      this.close();
      this.myTaskForm.reset();
      this.getSaveTask.emit(false);
      this.toastr.success("Task List created successfully.", '', {
        timeOut: 3000,
      });
    }
    else {
      this.spinner=false;
      this.close();
    } 
  }

  // async SaveSubTask(data){
  //   var ReqModel={
  //     tasklistID:0,
  //     parentTaskID: this.taskId,
  //     title: data.title,
  //     description: data.description,
  //     colourCode: this.selectedColor,
  //     isInternal: data.isInternal,
  //     dueDate: data.dueDate,
  //     organizationID: Number(this.organizationId),
  //     databaseID: Number(this.databaseId),
  //     userID: this.currentUser.UID,
  //     officeID: this.myOfficeID,
  //     officeIDList: this.OfficeIDList     
  //   }
  //  // return;
  //   this.spinner=true;
  //   this.myTaskForm.markAsPristine();
  //   const result = await this.coreService.addTask(ReqModel).toPromise();
  //   if (result.status === this.statusConst.statusSuccess) {
  //     this.spinner=false;
  //     this.close();
  //     this.myTaskForm.reset();
  //     this.getSaveTask.emit(false);
  //     this.toastr.success("Sub Task created successfully.", '', {
  //       timeOut: 3000,
  //     });
  //   }
  //   else {
  //     this.spinner=false;
  //     this.close();
  //   } 
  // }

  close() {
    this.myTaskForm.reset();
    this.getCloseCreateTask.emit(false);
  } 


  toggleColorSelection(){
    this.showColorPannel = !this.showColorPannel;
  }

  SelectColor(color:any) {
    this.selectedColor = color;
    this.showColorPannel=false;
  } 


  isAttachEntity = false;
  isAssignedEntity: boolean=false;
  entityTypeAttached: number = 1;
  entityTypeAssignee: number = 2;
  taskAssignedEntity: any = [] = [];
  taskAttachedEntity: any = [] = [];
  getTaskAssignedEntityInDetails: any = [] = [];
  getTaskAttachedEntityInDetails: any = [] = [];
  checkedContact: boolean = false;
  checkedRole: boolean = false;
  checkedRelationShip: boolean = false;
  checkedEmail: boolean = false;
  checkedUser: boolean = false;
  menuModulesList: any = [] = [];

  /* ---- Section tabs (Attach / Assign) ---- */
  sectionTabs: { id: string; label: string; title: string; icon: string }[] = [
    { id: 'attach', label: 'Attach', title: 'Attach To', icon: 'attach_file' },
    { id: 'assign', label: 'Assign', title: 'Assigned To', icon: 'person_outline' }
  ];
  activeSectionTab: string = 'attach';

  setSectionTab(tabId: string) {
    if (this.activeSectionTab === tabId) {
      return;
    }
    this.activeSectionTab = tabId;
    // let anything that measures itself re-run once the pane is visible
    setTimeout(() => {
      try {
        window.dispatchEvent(new Event('resize'));
      } catch (e) { }
    });
  }

  hasAttachedEntity(): boolean {
    const hasLive = (list: any) =>
      !!list && list.length > 0 && list.some((e: any) => !e || e.isDeleted !== true);
    return hasLive(this.attachedToSelectedCore)
      || hasLive(this.attachedToSelectedContact)
      || hasLive(this.attachedToSelectedCompany);
  }

  isSectionTabFilled(tabId: string): boolean {
    switch (tabId) {
      case 'attach':
        return this.hasAttachedEntity();
      case 'assign':
        return !!this.selectedAssignedTo && this.selectedAssignedTo.length > 0;
      default:
        return false;
    }
  }

  getAttached3c(event: any){
    if(event.checked==true){
       this.isAttachEntity = true;      
    }else{
      this.isAttachEntity = false;
      this.checkedAttachCore=false;
      this.checkedAttachContact=false;
      this.checkedAttachCompany=false;   
    }
   // this.showTaskUpdateButton = true;    
   }
   
   getAssigned3c(event: any){
    if(event.checked==true){
       this.isAssignedEntity = true;
    }else{
      this.isAssignedEntity = false;
      this.entityTypeAssignee = 0;
      this.checkedRole=false;
      this.checkedRelationShip=false;
      this.checkedUser=false;
      this.checkedContact=false;
      this.checkedEmail=false;
    }
    //this.showTaskUpdateButton = true;
   }


   // =========================================== Attached to ===========================================//
   
   
     ShowAttchedToCore: boolean = false;
     ShowAttchedToContact: boolean = false;
     ShowAttchedToCompany: boolean = false;
   
   
     attachedToCoreList: any = [] = [];
     attachedToContactList: any = [] = [];
     attachedToCompanyList: any = [] = [];
   
   
     attachedToSelectedCore: any = [] = [];
     attachedToSelectedContact: any = [] = [];
     attachedToSelectedCompany: any = [] = [];
   
     CorefolderID: number = 0;
     ContactfolderID: number = 0;
     CompanyfolderID: number = 0;
   
     roleIdList: any = [];
   
     checkedAttachCore: boolean = false;
     checkedAttachContact: boolean = false;
     checkedAttachCompany: boolean = false;
     timeout = null;
   
     selectCCC($event: MatRadioChange) {
       this.stateCtrl.reset();
       if ($event.value === 'Core') {
         this.ShowAttchedToCore = true;
         this.ShowAttchedToContact = false;
         this.ShowAttchedToCompany = false;
   
         this.checkedAttachCore = true;
         this.checkedAttachContact = false;
         this.checkedAttachCompany = false;
   
         this.entityTypeAttached = 1;
   
        // this.showFieldBased=true;
        // this.getSynonyms();
       }
       if ($event.value === 'Contact') {
         this.ShowAttchedToCore = false;
         this.ShowAttchedToContact = true;
         this.ShowAttchedToCompany = false;
   
         this.checkedAttachCore = false;
         this.checkedAttachContact = true;
         this.checkedAttachCompany = false;
   
         this.entityTypeAttached = 2;
        // this.showFieldBased=true;
        // this.getSynonyms();
       }
       if ($event.value === 'Company') {
         this.ShowAttchedToCore = false;
         this.ShowAttchedToContact = false;
         this.ShowAttchedToCompany = true;
   
         this.checkedAttachCore = false;
         this.checkedAttachContact = false;
         this.checkedAttachCompany = true;
   
         this.entityTypeAttached = 3;
        // this.showFieldBased=true;
        // this.getSynonyms();
       }
      // this.taskDetailList.documentFolderID=0;
      // this.selectedFolderID=0;
      // this.showTaskUpdateButton=true;
      // this.documentFolders=[];
       this.attachedToSelectedCore=[];
       this.attachedToSelectedContact=[];
       this.attachedToSelectedCompany=[];
     }
   
   
   
     //======================Core============================//
   
     searchCore(val:any) {
       if (val.length >= 2) {
         this.attachedToCoreList = [];
         if (val != '') {
           clearTimeout(this.timeout)
           this.timeout = setTimeout(() => {
             this.getsearchCore(val)
           }, 500);
         } else {
           this.attachedToCoreList = [];
         }
       }
     }
   
     getsearchCore(searchValue: any) {
       var SelectedCCC = [];
       SelectedCCC = this.menuModulesList.filter((x:any) => x.mainModuleName == 'Core');
       if (SelectedCCC.length > 0) {
         this.CorefolderID = SelectedCCC[0].folderID;
       }
       this.roleIdList = [];
       let roles = sessionStorage.getItem('roleIDList').split(',');
       roles.forEach(e => {
         this.roleIdList.push(Number(e));
       });
   
       var ReqModel = {
         roleIDList: this.roleIdList,
         searchKey: searchValue,
         userContactID: Number(sessionStorage.getItem('userContactID')),
         folderID: this.CorefolderID,
         databaseID: Number(this.databaseId),
         userID: this.currentUser.UID,
         officeID: this.myOfficeID,
         organizationID: Number(this.organizationId),
         officeIDList: this.OfficeIDList
       }
       this.settingsService.searchCore(ReqModel).subscribe(response => {
         if (response != undefined) {
           this.responseHolder = response;
           if (this.responseHolder.status == this.statusConst.statusSuccess) {
             this.attachedToCoreList = response.data;   
           } else {
             this.attachedToCoreList = [];
           }
         }
       })
     }
   
   
     attchedToCoreSelected(coreSelected: any) {
       var checkCore = [];
       this.stateCtrl.setValue('');
       checkCore = this.attachedToSelectedCore.filter((x:any) => x.isDeleted == false);
       if (checkCore.length == 0) {
         var shortName = "";
         shortName = coreSelected.name.match(/\b(\w)/g).join('');
         var ReqModel = {
           taskAttachedEntityID: 0,
           coreID: coreSelected.coreID,
           email: coreSelected.email,
           name: coreSelected.name,
           title: coreSelected.title,
           transactionID: coreSelected.transactionID,
           img: coreSelected.imageUrl,
           typeID: coreSelected.typeID,
           isDeleted: false,
           shortName: shortName,
         }
         this.attachedToSelectedCore.unshift(ReqModel);
         this.stateCtrl.reset();
         if (this.attachedToSelectedCore.length > 0) {
          // this.showTaskUpdateButton = true;
         } else {
          // this.showTaskUpdateButton = false;
         }   
   
         if(coreSelected.email!=""){   
           //var email =this.myTaskForm.get('repeatTaskEmail').value;
          // email+= coreSelected.email+',';           
          // this.myTaskForm.controls['repeatTaskEmail'].setValue(email);          
         }
        
     }
     //this.getNormalAndSharedCompanys(coreSelected.coreID);
    // this.getNormalAndSharedContacts(coreSelected.coreID);
    // this.GetAttachedEntityDocumentFolders(coreSelected.coreID,1);    
     }
   
     attchedToRemoveCore(item: any) {
       if (this.attachedToSelectedCore.length > 0) {
         this.attachedToSelectedCore.map(e => {
           if (e.coreID == item.coreID) {
             e.isDeleted = true
           }
           return e;
         });
         //this.showTaskUpdateButton = false;
         //this.entityTypeAttached = 0
       //  this.documentFolders=[];
       //  this.selectedFolderID=0;
   
        //  if(item.email){
        //    var email =this.myTaskForm.get('repeatTaskEmail').value;
        //    var array=[];
        //     array = email.split(',');
        //     if(array.length>0){
        //      array = array.filter(e => e !== item.email);
        //      if(array.length>0){
        //        var test = array.join(",")
        //        this.myTaskForm.controls['repeatTaskEmail'].setValue(test);
        //       }      
        //     }else{
        //     //  this.filtersFormArrayNotification.value.length=0;
        //     //  this.dynamicFormNotification = this.formBuilder.group({
        //     //    filtersmNotification: this.formBuilder.array([])
        //     //  });
        //     //  this.showRepeatTaskEmail=false;
        //     }
        //   } 
       }
     
       var checkCore = [];
       checkCore = this.attachedToSelectedCore.filter((x:any) => x.isDeleted == false);
       if (checkCore.length == 0) {
         this.stateCtrl.reset();
        // this.showTaskUpdateButton = false;
       } else {
         this.stateCtrl.reset();
        // this.showTaskUpdateButton = true;
       }
       //this.showTaskUpdateButton = true;
       //this.isAttachEntity = false;    
     }
   
   
   
   
     //======================Contact============================//
   
     searchContacts(val:any) {
       if (val.length >= 2) {
         this.attachedToContactList = [];
         if (val != '') {
           clearTimeout(this.timeout)
           this.timeout = setTimeout(() => {
             this.getsearchContact(val)
           }, 500);
         } else {
           this.attachedToContactList = [];
         }
       }
     }
   
     onfolderSelectionChanged(val:any){
     // this.selectedFolderID=val.value;
     }
   
     documentFolders:any=[]=[];
     selectedFolderID:number=0;

     GetAttachedEntityDocumentFolders(entityID: any,AttachedEntityType:any) {    
       var ReqModel = {
         userID: this.currentUser.UID,
         officeID: this.myOfficeID,
         organizationID: Number(this.organizationId),
         TransactionID: entityID,
         AttachedEntityType: AttachedEntityType,
       }
       this.coreService.GetAttachedEntityDocumentFolders(ReqModel).subscribe(response => {
         if (response != undefined) {
           this.responseHolder = response;
           if (this.responseHolder.status == this.statusConst.statusSuccess) {
             this.documentFolders = response.data;              
           }else{
             this.documentFolders=[];
           }
          }
        })
     }
   
   
     getsearchContact(searchValue: any) {
       var SelectedCCC = [];
   
       SelectedCCC = this.menuModulesList.filter((x:any) => x.mainModuleName == 'Contact');
       if (SelectedCCC.length > 0) {
         this.ContactfolderID = SelectedCCC[0].folderID;
       }
       this.roleIdList = [];
       let roles = sessionStorage.getItem('roleIDList').split(',');
       roles.forEach(e => {
         this.roleIdList.push(Number(e));
       });
   
       var ReqModel = {
         roleIDList: this.roleIdList,
         searchKey: searchValue,
         userContactID: Number(sessionStorage.getItem('userContactID')),
         folderID: this.ContactfolderID,
         databaseID: Number(this.databaseId),
         userID: this.currentUser.UID,
         officeID: this.myOfficeID,
         organizationID: Number(this.organizationId),
         officeIDList: this.OfficeIDList
       }
       this.settingsService.searchContact(ReqModel).subscribe(response => {
         if (response != undefined) {
           this.responseHolder = response;
           if (this.responseHolder.status == this.statusConst.statusSuccess) {
             this.attachedToContactList = response.data;   
           } else {
             this.attachedToContactList = [];
           }
         }
       })
     }
   
   
     attchedToContactSelected(contactSelected: any) {
       var checkContact = [];
       this.stateCtrl.setValue('');
       checkContact = this.attachedToSelectedContact.filter((x:any) => x.isDeleted == false);
       if (checkContact.length == 0) {
         var shortName = "";
         shortName = contactSelected.name.match(/\b(\w)/g).join('');
         var ReqModel = {
           taskAttachedEntityID: 0,
           contactID: contactSelected.contactID,
           email: contactSelected.email,
           name: contactSelected.name,
           title: contactSelected.title,
           transactionID: contactSelected.transactionID,
           img: contactSelected.imageUrl,
           typeID: contactSelected.typeID,
           isDeleted: false,
           shortName: shortName,
         }
         this.attachedToSelectedContact.unshift(ReqModel);
         this.stateCtrl.reset();
         if (this.attachedToSelectedContact.length > 0) {
         //  this.showTaskUpdateButton = true;
         } else {
          // this.showTaskUpdateButton = false;
         }  
   
        //  if(contactSelected.email!=""){
   
        //    var email =this.myTaskForm.get('repeatTaskEmail').value;
        //    //  this.repeatTaskEmail+= contactSelected.email+','; 
        //       email+= contactSelected.email+','; 
        //     // this.repeatTaskEmail=this.repeatTaskEmail.replace(/,(\s+)?$/, '');  
        //     // this.myTaskForm.controls['repeatTaskEmail'].setValue(this.repeatTaskEmail);
        //      this.myTaskForm.controls['repeatTaskEmail'].setValue(email);
   
        //  //   this.repeatTaskEmail+= contactSelected.email+','; 
        //  //  // this.repeatTaskEmail=this.repeatTaskEmail.replace(/,(\s+)?$/, '');  
        //  //   this.myTaskForm.controls['repeatTaskEmail'].setValue(this.repeatTaskEmail);
        //  }
   
     }
     //this.GetContactSelectedContact(contactSelected.contactID);
     //this.GetAttachedEntityDocumentFolders(contactSelected.contactID,2);    
   }
   
   
     attchedToRemoveContact(item: any) {
       if (this.attachedToSelectedContact.length > 0) {
         this.attachedToSelectedContact.map(e => {
           if (e.contactID == item.contactID) {
             e.isDeleted = true
           }
           return e;
         });
        // this.showTaskUpdateButton = false;     
         this.documentFolders=[];
        // this.selectedFolderID=0;
   
        //  if(item.email){
        //    var email =this.myTaskForm.get('repeatTaskEmail').value;
        //    var array=[];
        //     array = email.split(',');
        //     if(array.length>0){
        //      array = array.filter(e => e !== item.email);
        //      if(array.length>0){
        //        var test = array.join(",")
        //        this.myTaskForm.controls['repeatTaskEmail'].setValue(test);
        //       }      
        //     }else{
        //     //  this.filtersFormArrayNotification.value.length=0;
        //     //  this.dynamicFormNotification = this.formBuilder.group({
        //     //    filtersmNotification: this.formBuilder.array([])
        //     //  });
        //     //  this.showRepeatTaskEmail=false;
        //     }
        //   } 
       }
   
       var checkContact = [];
       checkContact = this.attachedToSelectedContact.filter((x:any) => x.isDeleted == false);
       if (checkContact.length == 0) {
         this.stateCtrl.reset();
       //  this.showTaskUpdateButton = false;
       } else {
         this.stateCtrl.reset();
        // this.showTaskUpdateButton = false;
       }
      // this.showTaskUpdateButton = true;
     }
   
   
   
   
   
     //======================Company============================//
   
     searchCompany(val:any) {
       if (val.length >= 2) {
         this.attachedToCompanyList = [];
         if (val != '') {
           clearTimeout(this.timeout)
           this.timeout = setTimeout(() => {
             this.getsearchCompany(val)
           }, 500);
         } else {
           this.attachedToCompanyList = [];
         }
       }
     }
   
     getsearchCompany(searchValue: any) {
       var SelectedCCC = [];
   
       SelectedCCC = this.menuModulesList.filter((x:any) => x.mainModuleName == 'Company');
       if (SelectedCCC.length > 0) {
         this.CompanyfolderID = SelectedCCC[0].folderID;
       }
   
       this.roleIdList = [];
   
       let roles = sessionStorage.getItem('roleIDList').split(',');
       roles.forEach(e => {
         this.roleIdList.push(Number(e));
       });
   
       var ReqModel = {
         roleIDList: this.roleIdList,
         searchKey: searchValue,
         userContactID: Number(sessionStorage.getItem('userContactID')),
         folderID: this.CompanyfolderID,
         databaseID: Number(this.databaseId),
         userID: this.currentUser.UID,
         officeID: this.myOfficeID,
         organizationID: Number(this.organizationId),
         officeIDList: this.OfficeIDList
       }
       this.settingsService.searchCompany(ReqModel).subscribe(response => {
         if (response != undefined) {
           this.responseHolder = response;
           if (this.responseHolder.status == this.statusConst.statusSuccess) {
             this.attachedToCompanyList = response.data;   
           } else {
             this.attachedToCompanyList = [];
           }
         }
       })
     }
   
   
   
     attchedToCompanySelected(companySelected: any) {
       var checkCompany = [];
       this.stateCtrl.setValue('');
       checkCompany = this.attachedToSelectedCompany.filter((x:any) => x.isDeleted == false);
       if (checkCompany.length == 0) {
         var shortName = "";
         shortName = companySelected.name.match(/\b(\w)/g).join('');
         var ReqModel = {
           taskAttachedEntityID: 0,
           companyID: companySelected.companyID,
           email: companySelected.email,
           name: companySelected.name,
           title: companySelected.title,
           transactionID: companySelected.transactionID,
           img: companySelected.imageUrl,
           typeID: companySelected.typeID,
           isDeleted: false,
           shortName: shortName,
         }
         this.attachedToSelectedCompany.unshift(ReqModel);
         this.stateCtrl.reset();
         if (this.attachedToSelectedCompany.length > 0) {
          // this.showTaskUpdateButton = true;
         } else {
          // this.showTaskUpdateButton = false;
         }    
   
        //  if(companySelected.email!=""){
        //    var email =this.myTaskForm.get('repeatTaskEmail').value;
        //    //  this.repeatTaskEmail+= contactSelected.email+','; 
        //       email+= companySelected.email+','; 
        //     // this.repeatTaskEmail=this.repeatTaskEmail.replace(/,(\s+)?$/, '');  
        //     // this.myTaskForm.controls['repeatTaskEmail'].setValue(this.repeatTaskEmail);
        //      this.myTaskForm.controls['repeatTaskEmail'].setValue(email);
   
        //  //   this.repeatTaskEmail+= companySelected.email+','; 
        //  //  // this.repeatTaskEmail=this.repeatTaskEmail.replace(/,(\s+)?$/, '');  
        //  //   this.myTaskForm.controls['repeatTaskEmail'].setValue(this.repeatTaskEmail);
        //  }
   
      }    
    // this.GetCompanySelectedContact(companySelected.companyID);
    // this.GetAttachedEntityDocumentFolders(companySelected.companyID,3);   
   }
   
     attchedToRemoveCompany(item: any) {
       if (this.attachedToSelectedCompany.length > 0) {
         this.attachedToSelectedCompany.map(e => {
           if (e.companyID == item.companyID) {
             e.isDeleted = true
           }
           return e;
         });
        //  this.showTaskUpdateButton = false;
        //  this.documentFolders=[];
        //  this.selectedFolderID=0;
   
        //  if(item.email){
        //    var email =this.myTaskForm.get('repeatTaskEmail').value;
        //    var array=[];
        //     array = email.split(',');
        //     if(array.length>0){
        //      array = array.filter(e => e !== item.email);
        //      if(array.length>0){
        //        var test = array.join(",")
        //        this.myTaskForm.controls['repeatTaskEmail'].setValue(test);
        //       }      
        //     }else{
        //     //  this.filtersFormArrayNotification.value.length=0;
        //     //  this.dynamicFormNotification = this.formBuilder.group({
        //     //    filtersmNotification: this.formBuilder.array([])
        //     //  });
        //     //  this.showRepeatTaskEmail=false;
        //     // }
        //   } 
   
        //  }
       var checkCompany = [];
       checkCompany = this.attachedToSelectedCompany.filter((x:any) => x.isDeleted == false);
       if (checkCompany.length == 0) {
         this.stateCtrl.reset();
        // this.showTaskUpdateButton = false;
       } else {
         this.stateCtrl.reset();
        // this.showTaskUpdateButton = true;
       }
      // this.showTaskUpdateButton = true;
     }  
        
    }


    getShortName(fullName:any) {
       if (fullName != undefined) {
         if (fullName.includes(' ')) {
           return fullName
             .split(' ')
             .map((n) => n[0])
             .join('');
         }
         return fullName.substring(0, 1);
       }
       return '';
     }
   
   
  selectedAssignedTo: any = [] = [];
  selectedUIRelationship: any=[];
  resultUIRelationship: any=[];
  relationShips: any=[];

   removeAssignedTo(item: any) {
    const index = this.selectedAssignedTo.indexOf(item);
    if (index >= 0) {
      this.selectedAssignedTo.splice(index, 1);
     // this.showTaskUpdateButton = true;
    }
    if (this.selectedAssignedTo.length > 0) {
    //  this.showTaskUpdateButton = true;
    }

    // if(item.email){
    //   var email =this.myTaskForm.get('repeatTaskEmail').value;
    //   var array=[];
    //    array = email.split(',');
    //    if(array.length>0){
    //     array = array.filter(e => e !== item.email);
    //     if(array.length>0){
    //       var test = array.join(",")
    //       this.myTaskForm.controls['repeatTaskEmail'].setValue(test);
    //      }      
    //    }else{
    //     // this.filtersFormArrayNotification.value.length=0;
    //     // this.dynamicFormNotification = this.formBuilder.group({
    //     //   filtersmNotification: this.formBuilder.array([])
    //     // });
    //     // this.showRepeatTaskEmail=false;
    //    }
    //  }  
  }
  

  // ======================= User ===============================//

  selectedUser: any = [] = [];
  userList: any = [];
  ShowRelationshipBox: boolean=false; 
  ShowContactBox: boolean = false;
  ShowRoleBox: boolean = false;
  ShowEmailBox: boolean = false;
  ShowUserBox: boolean = false;

  searchUser(val:any) {
    if (val.length >= 2) {
      this.userList = [];
      if (val != '') {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.getUserListCoreImplementation(val)
        }, 500);
      } else {
        this.userList = [];
      }
    }
  }

  searchRelationShip(val:any) {
    if (val.length >= 2) {
      this.resultUIRelationship = [];
      if (val != '') {
        this.relationShips.forEach(rs => {
          if(rs.rloeName.toLowerCase().includes(val))
          {
            if(!this.resultUIRelationship.includes(rs))
            this.resultUIRelationship.push(rs);
          }
        });
      } else {
        this.resultUIRelationship = [];
      }
    }
  }


  getUserListCoreImplementation(searchValue: any) {
    if (searchValue == "" || searchValue == null || searchValue == undefined) {
      this.userList = [];
      return;
    }
    var ReqModel = {
      DatabaseID: Number(this.databaseId),
      OrganizationID: Number(this.organizationId),
      officeID:this.myOfficeID,
      searchKey: searchValue.trim(),
      PageSize: 0,
      pageIndex: 0,
      UserID: this.currentUser.UID
    }
    this.settingsService.GetUserList(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.userList = response.data.userModel;
          this.userList.map((res:any) => {
            if (res.email != null) {
              res.email = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.email);
            }
            if (res.firstName != null) {
              res.firstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.firstName);
            }
            if (res.lastName != null) {
              res.lastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.lastName);
            }
            return res;
          });
          this.userList = this.userList;
        }
      }
    });
  }

  getUserListCoreImplementationDashboard(searchValue: any) {
    if (searchValue == "" || searchValue == null || searchValue == undefined) {
      this.userList = [];
      return;
    }
    var ReqModel = {
      DatabaseID: Number(this.databaseId),
      OrganizationID: Number(this.organizationId),
      officeID:this.myOfficeID,
      searchKey: searchValue.trim(),
      PageSize: 0,
      pageIndex: 0,
      UserID: this.currentUser.UID
    }
    this.settingsService.GetUserList(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.userList = response.data.userModel;
          this.userList.map((res:any) => {
            if (res.email != null) {
              res.email = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.email);
            }
            if (res.firstName != null) {
              res.firstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.firstName);
            }
            if (res.lastName != null) {
              res.lastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.lastName);
            }
            return res;
          });
          this.userList = this.userList;

          if(this.userList.length>0){
           this.userSelected(this.userList[0]);
          }
        }
      }
    });
  }

  relationSelected(rs: any) {
    if(!this.selectedUIRelationship.find(m=>m.transctionalRoleID==rs.transctionalRoleID && m.id==rs.id)){
       this.selectedUIRelationship.push(rs);
    }
      if (this.selectedUIRelationship.length > 0) {
       // this.showTaskUpdateButton = true;
      }
      else {
       // this.showTaskUpdateButton = false;
      }
      this.stateCtrl.setValue('');
  }


  userSelected(userSelected: any) {
    this.stateCtrl.setValue('');
    var user=[];
     user = this.selectedAssignedTo.filter(m => m.userID == userSelected.uuid && m.entityTypeAssignee==4);
    if (user.length==0) {

      var shortName = userSelected.firstName.match(/\b(\w)/g).join('');

      this.selectedAssignedTo.push({
         name: userSelected.firstName + " " + userSelected.lastName,
         taskAssignedEntityID: 0,
         taskID: this.taskId,
         email: userSelected.email,
         contactID: 0,
         role:  0,
         userID: userSelected.uuid,
         entityTypeAssignee:4,
         img: "",
         shortName:shortName       
      });     

      if(userSelected.email!=""){
         var email =this.myTaskForm.get('repeatTaskEmail').value;      
           email+= userSelected.email+',';         
          this.myTaskForm.controls['repeatTaskEmail'].setValue(email);       
      }
    }else{
      this.toastr.warning('User allready added.', '', {
        timeOut: 3000,
      });
    }
    if(this.selectedAssignedTo.length > 0) {
     // this.showTaskUpdateButton = true;
    }
    else {
    //  this.showTaskUpdateButton = false;
    }
  }

  removeUser(item: any) {
    const index = this.selectedUser.indexOf(item);
    if (index >= 0) {
      this.selectedUser.splice(index, 1);
     //this.showTaskUpdateButton = true;
    }
    if (this.selectedUser.length == 0) {
      this.stateCtrl.reset();
    }
  }

  removeRs(item: any) {
    const index = this.selectedUIRelationship.indexOf(item);
    if (index >= 0) {
      this.selectedUIRelationship.splice(index, 1);
    //  this.showTaskUpdateButton = true;
    }
    if (this.selectedUIRelationship.length == 0) {
      this.stateCtrl.reset();
    }
  }

  // ======================= Email ===============================//
  
    selectedEmail: any = [] = [];
    emailAssigned: string = "";
    addEmailButtonShow: boolean = false;
  
    emailCheck(searchValue: any) {
      if (searchValue.toLowerCase() == searchValue.toLowerCase().match('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')) {
        this.emailAssigned = searchValue;
        this.addEmailButtonShow = true;
      } else {
        this.addEmailButtonShow = false;
      }
    }
  
    addEmail() {    
      var check = [];
      check = this.selectedAssignedTo.filter((x:any) => x.email.toLowerCase() == this.emailAssigned.toLowerCase()
      && x.entityTypeAssignee==3)
  
      let toArray =  this.emailAssigned.split("@");
      var shortName = toArray[0].match(/\b(\w)/g).join('');    
      if (check.length == 0) {
        var obj={
          name: "",
          taskAssignedEntityID: 0,
          taskID: this.taskId,
          email: this.emailAssigned,
          contactID: 0,
          role:  0,
          userID: null,
          entityTypeAssignee:3,
          img: "",
          shortName:shortName
        }
        this.selectedAssignedTo.push(obj);     
       
  
        if(this.emailAssigned!=""){
          var email =this.myTaskForm.get('repeatTaskEmail').value;     
           email+= this.emailAssigned+',';       
          this.myTaskForm.controls['repeatTaskEmail'].setValue(email);
        }
  
        this.emailAssigned = "";
        this.addEmailButtonShow = false;
  
      } else {
        this.emailAssigned = "";
        this.addEmailButtonShow = false;
        this.toastr.warning('Email allready added.', '', {
          timeOut: 3000,
        });
     }
      
  
      if (this.selectedAssignedTo.length > 0) {
      //  this.showTaskUpdateButton = true;
      }
      if (this.selectedAssignedTo.length == 0) {
      //  this.showTaskUpdateButton = false;
      }
    }
  
    removeEmail(item: any) {
      const index = this.selectedEmail.indexOf(item);
      if (index >= 0) {
        this.selectedEmail.splice(index, 1);
      }
      if (this.selectedEmail.length > 0) {
      //  this.showTaskUpdateButton = true;
      }   
    }

     contactsList: any = [];
     RoleList: any = [];
     selectedContacts: any = [] = [];

     selectCRE($event: MatRadioChange) {
    
        this.addEmailButtonShow = false;
      //  this.showTaskUpdateButton = true;
    
        // For Contact
     
        this.stateCtrl.reset();
        this.contactsList = [];
    
        // For Role
        this.RoleList = [];
    
        //For Email
        this.emailAssigned = "";
    
        // For User
        this.selectedUser = [];    
    
        // clear taskAssigned
        this.taskAssignedEntity = [];
    
        if ($event.value === 'Contact') {
          this.ShowContactBox = true;
          this.ShowRoleBox = false;
          this.ShowEmailBox = false;
          this.ShowUserBox = false;
          this.ShowRelationshipBox = false;
          this.entityTypeAssignee = 1;
        }
        if ($event.value === 'Role') {
          this.ShowContactBox = false;
          this.ShowRoleBox = true;
          this.ShowEmailBox = false;
          this.ShowUserBox = false;
          this.ShowRelationshipBox = false;
          this.entityTypeAssignee = 2;
        }
        if ($event.value === 'Email') {
          this.ShowContactBox = false;
          this.ShowRoleBox = false;
          this.ShowEmailBox = true;
          this.ShowUserBox = false;
          this.ShowRelationshipBox = false;
          this.entityTypeAssignee = 3;
        }
        if ($event.value === 'User') {
          this.ShowContactBox = false;
          this.ShowRoleBox = false;
          this.ShowEmailBox = false;
          this.ShowUserBox = true;
          this.ShowRelationshipBox = false;
          this.entityTypeAssignee = 4;
        }
        if ($event.value === 'Relationship') {
          this.ShowContactBox = false;
          this.ShowRoleBox = false;
          this.ShowEmailBox = false;
          this.ShowUserBox = false;
          this.ShowRelationshipBox = true;
          this.entityTypeAssignee = 5;
        }
      }

   searchContact(val:any) {
    if (val.length >= 2) {
      this.contactsList = [];
      if (val != '') {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.getContactListCoreImplementation(val)
        }, 500);
      } else {
        this.contactsList = [];
      }
    }
  }

  getContactListCoreImplementation(searchValue: any) {
    var ReqModel = {
      DatabaseID: Number(this.databaseId),
      OrganizationID: Number(this.organizationId),
      UserID: this.currentUser.UID,
      searchValue: searchValue,
      PageSize: 0,
    }
    this.settingsService.GetContactListCoreImplementation(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.contactsList = response.data.contactListModel;
          this.contactsList.forEach((e:any) => {
            e.shortName = e.name.match(/\b(\w)/g).join('');
          });
        } else {
          this.contactsList = [];
        }
      }
    })
  }


  onEnter(event:any, contact:any) {
    this.stateCtrl.setValue('');
    var findContact = this.selectedContacts.filter((x:any) => x.name === event.target.value);
    if (findContact.length != undefined && findContact.length > 0) {
      let user = this.selectedContacts.find((m:any) => m.contactID == findContact[0].contactID);
      if (user == undefined || user == '' || user == null) {
        var req = {
          contactID: findContact[0].contactID,
          email: findContact[0].email,
          name: findContact[0].name,
          img: findContact[0].imageUrl,
          shortName: findContact[0].shortName
        }
        this.selectedContacts.unshift(req);
        this.stateCtrl.reset();
        if (this.selectedContacts.length > 0) {
         // this.showTaskUpdateButton = true;
        }
        else {
         // this.showTaskUpdateButton = false;
        }
      } else {
        this.stateCtrl.reset();
        if (this.selectedContacts.length > 0) {
         // this.showTaskUpdateButton = true;
        }
        else {
        //  this.showTaskUpdateButton = false;
        }
      }
    }
  }

  contactSelected(contactSelected: any) {
    this.stateCtrl.setValue('');
    this.stateCtrl.reset();
    var user=[];
    user = this.selectedAssignedTo.filter(m => m.contactID == contactSelected.contactID && m.entityTypeAssignee==1);
     if (user.length==0) {

      var shortName = contactSelected.name.match(/\b(\w)/g).join('');

      var ReqModel = {
         name: contactSelected.name,
         taskAssignedEntityID: 0,
         taskID: this.taskId,
         email: contactSelected.email,
         contactID: contactSelected.contactID,
         role:  0,
         userID: null,
         entityTypeAssignee:1,
         img: contactSelected.imageUrl,
         shortName:shortName    
      }
      this.selectedAssignedTo.push(ReqModel);     
     
      if(contactSelected.email!=""){
        // var email =this.myTaskForm.get('repeatTaskEmail').value;     
        //  email+= contactSelected.email+',';       
        //  this.myTaskForm.controls['repeatTaskEmail'].setValue(email);
      }
    }else{
      this.toastr.warning('Contact allready added.', '', {
        timeOut: 3000,
      });
    }
    if(this.selectedAssignedTo.length > 0) {
     // this.showTaskUpdateButton = true;
    }
    if(this.selectedAssignedTo.length == 0) {
    //  this.showTaskUpdateButton = false;
    }
  }

  removeContact(item: any) {
    const index = this.selectedContacts.indexOf(item);
    if (index >= 0) {
      this.selectedContacts.splice(index, 1);
     // this.showTaskUpdateButton = true;
    }
    if (this.selectedContacts.length == 0) {
      this.stateCtrl.reset();
     // this.showTaskUpdateButton = false;
    }
    else{
     // this.showTaskUpdateButton=true;
    }  
   
  }


 // =========================== For Role  ===============================//

  selectedRole: any = [] = [];

  searchRoles(searchValue: any) {
    var ReqModel = {
      searchKey: "",
      pageIndex: 0,
      pageSize: 0,
      databaseID: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      searchValue: searchValue
    }
    this.settingsService.getSharedAccessRoles(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.RoleList = response.data;
        }
        else {
        }
      }
    });
  }

  roleSelected(roleSelected: any) {
      this.stateCtrl.setValue('');
      var newRole=[];   
      newRole = this.selectedAssignedTo.filter(m => m.roleID == roleSelected.roleID && m.entityTypeAssignee==2);
      if (newRole.length==0) {
       
        var shortName = roleSelected.roleName.match(/\b(\w)/g).join('');
       
        this.selectedAssignedTo.push({        
         name: roleSelected.roleName,
         taskAssignedEntityID: 0,
         taskID: this.taskId,
         email: "",
         contactID: 0,
         roleID:  roleSelected.roleID,
         userID: null,
         entityTypeAssignee:2,
         img: "",
         shortName:shortName
        });
        if (this.selectedAssignedTo.length > 0) {
         // this.showTaskUpdateButton = true;
        }
        if (this.selectedAssignedTo.length == 0) {
         // this.showTaskUpdateButton = false;
        }
      }else{       
        this.toastr.warning('Role allready added.', '', {
          timeOut: 3000,
        });
      }

      if (this.selectedAssignedTo.length > 0) {
       // this.showTaskUpdateButton = true;
      }  
    
  }

  removeRole(item: any) {
    const index = this.selectedAssignedTo.indexOf(item);
    if (index >= 0) {
      this.selectedAssignedTo.splice(index, 1);
     // this.showTaskUpdateButton = true;
    }
    if (this.selectedAssignedTo.length > 0) {
     // this.showTaskUpdateButton = true;
    }
  }

 


}
